import { getMetaData } from "../data/redux-state"
import * as React from "react"
import { formatToSignificantDigits } from "../utils/format"
import { useIntl } from "gatsby-plugin-intl"
import { extractOptionalTranslation } from "./VariableDropdown"

export const TooltipClickOnDataPoints = (props: any) => {
  const intl = useIntl()
  const xPosition = props.click[0]
  const yPosition = props.click[1]
  const styles = {
    left: `${xPosition}px`,
    top: `${yPosition}px`,
    position: "absolute",
    zIndex: 10,
    backgroundColor: "white",
    padding: "5px",
    borderRadius: "5px",
    boxShadow: "4px 4px 10px rgba(0, 100, 100, 0.4)",
    fontSize: window.innerWidth >= window.innerHeight ? "14px" : "10px",
    fontWeight: "normal",
    fontFamily: "sans-serif",
  }
  const textContainerStyles = {
    display: "flex",
    flexDirection: "column",
    gap: "2px",
    lineHeight: 1.1,
  } as const
  const metaData: FileMetadata | null = getMetaData(props.appState)
  const precision = getPrecision(metaData)
  const varUnit = extractOptionalTranslation({
    parentKey: "varUnits",
    subKey: String(metaData?.VarUnit),
    intl,
  })
  const formattedNumber = formatToSignificantDigits(
    props.dataPoint.value,
    precision
  )
  return (
    <div
      onClick={() => props.removeClickedDots()}
      className="Tooltip"
      style={styles as any}
    >
      <div style={textContainerStyles}>
        <div>{formattedNumber + " " + varUnit}</div>
        <div>{props.dataPoint.date.getFullYear()}</div>
      </div>
    </div>
  )
}

function getPrecision(_metaData: FileMetadata | null): number {
  return 4
}
